(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-step-bar"] && !Shopify.designMode) return;
  try {
    
  class StepBar extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.step-bar__track');
      if (!this.track) return;

      this.lastWidth = -1;
      this.desktopQuery = window.matchMedia('(min-width: 750px)');
      this.handleResize = this.handleResize.bind(this);
      this.observer = new ResizeObserver(this.handleResize);
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    handleResize() {
      const width = this.clientWidth;
      if (width === this.lastWidth) return;
      this.lastWidth = width;

      this.classList.remove('step-bar--vertical');

      if (!this.desktopQuery.matches) return;

      requestAnimationFrame(() => {
        const isOverflowing = this.track.scrollWidth - this.track.clientWidth > 1;
        if (isOverflowing) this.classList.add('step-bar--vertical');
      });
    }
  }

  if (!customElements.get('step-bar')) {
    customElements.define('step-bar', StepBar);
  }

  } catch(e) { console.error(e); }
})();
})();
